import { QueryConfig } from "store/utils/query-config";

export const suppliersDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    limit: 500,
    sortBy: ["name"],
  },
};
